import { rpcCall } from './rpc-client';

export type TipperEmployeeGoal = {
  currentAmount: number;
  targetAmount: number;
  text: string;
};

export type TipperEmployeeRating = {
  count: number;
  score: string;
};

export type TipperEmployeeProfile = {
  avatarUrl?: string;
  firstName?: string;
  goal: TipperEmployeeGoal;
  lastName?: string;
  rating?: TipperEmployeeRating;
  uuid: string;
};

export type ThankArgs = {
  amount: number;
  comment?: string;
  debugTopUpNow?: boolean;
  feeBearer: 'sender' | 'receiver';
  idempotencyKey: string;
  paymentMethod?: string;
  phoneNumber?: string;
  score?: number;
  walletId: string;
};

export type ThankResult = {
  paymentUrl: string;
};

export function getTipperEmployeeProfile(
  walletUUID: string,
): Promise<TipperEmployeeProfile> {
  return rpcCall<TipperEmployeeProfile>('Tipper.GetEmployeeProfile', {
    walletId: walletUUID,
  });
}

export function thankTipper(args: ThankArgs): Promise<ThankResult> {
  return rpcCall<ThankResult>('Tipper.Thank', args);
}
